import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "jspdf-autotable";
import { Link } from "react-router-dom";

import html2canvas from "html2canvas";

const Profile = () => {
  const {orderId} =  useParams (); 
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [cart, setCart] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showQuotationModal, setShowQuotationModal] = useState(false); // State for modal visibility
  const [selectedOrder, setSelectedOrder] = useState(null); // State for selected order

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      navigate("/login");
    } else {
      fetchUserProfile(userId, token);
      fetchUserOrders(userId, token);
      fetchUserCart(userId);
    }
  }, []);

  // ✅ Fetch User Profile
  const fetchUserProfile = async (userId, token) => {
    try {
      const response = await axios.get(`https://api.irfanelectricals.com/user/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setUser(response.data.user);
      } else {
        handleLogout();
      }
    } catch (error) {
      console.error("❌ Error fetching user:", error);
      handleLogout();
    }
  };

  // ✅ Fetch Orders
  const fetchUserOrders = async (userId, token) => {
    try {
      const response = await axios.get(`https://api.irfanelectricals.com/api/orders/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setOrders(response.data.orders || []);
      }
    } catch (error) {
      console.error("❌ Error fetching orders:", error);
      setOrders([]);
    }
  };

  // ✅ Fetch Cart Items
  const fetchUserCart = async (userId) => {
    try {
      const response = await axios.get(`https://api.irfanelectricals.com/api/cart/${userId}`);
      if (response.data.success) {
        setCart(response.data.cart || []);
        setItems(response.data.items || []);
      }
    } catch (error) {
      console.error("❌ Error fetching cart:", error);
      setCart([]);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Logout function
  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("token");
    navigate("/login");
  };

  // ✅ Handle View Quotation


  // ✅ Handle Close Quotation Modal
  const handleCloseQuotationModal = () => {
    setShowQuotationModal(false);
    setSelectedOrder(null);
  };

  // ✅ Generate Quotation PDF


  if (loading) {
    return <p>Loading profile...</p>;
  }

  return (
    <>
      <Navbar />
      <section className="container mt-4">
        <div className="card p-4 shadow-lg">
          <h2 className="text-center">My Profile</h2>
          {user ? (
            <div className="row">
              {/* ✅ User Email & Logout Button Only */}
              <div className="col-md-4 mx-auto">
                <div className="card p-3 text-center">
                  <p><strong>Email:</strong> {user.email}</p>
                  <button className="btn btn-danger mt-3" onClick={handleLogout}>
                    Logout
                  </button>
                </div>
              </div>

              {/* ✅ Order History */}
              <div className="col-md-8">
                <h4>Order History</h4>
                {orders.length > 0 ? (
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Total Price ($)</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map((order) => (
                        <tr key={order.id}>
                          <td>{order.id}</td>
                          <td>${order.total_price.toFixed(2)}</td>
                          <td>
                            <span className={`badge bg-${order.status === "Completed" ? "success" : "warning"}`}>
                              {order.status}
                            </span>
                          </td>
                          <td>
                            <Link to={`/order/${order.id}`} className="btn btn-primary btn-sm me-2">
                              View Order
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No orders found.</p>
                )}
              </div>

              {/* ✅ Cart Items */}
              <div className="col-md-12 mt-4">
                <h4>My Cart</h4>
                {items.length > 0 ? (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Product</th>
                        <th>Price ($)</th>
                        <th>Quantity</th>
                        <th>Subtotal ($)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item) => (
                        <tr key={item._id}>
                          <td>
                            <img
                              src={item.images.length > 0 ? `https://api.irfanelectricals.com/uploads/${item.images[0]}` : "https://via.placeholder.com/150"}
                              alt={item.product_name}
                              width="60"
                              height="60"
                              className="rounded"
                            />
                          </td>
                          <td>{item.product_name}</td>
                          <td>${item.price.toFixed(2)}</td>
                          <td>{item.quantity}</td>
                          <td>${(item.price * item.quantity).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>Your cart is empty.</p>
                )}
              </div>
            </div>
          ) : (
            <p>No user data available.</p>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Profile;